import { gtag } from '@worldcoo/ui/lib/analytics';

/**
 * In an embed the integrator already collected consent, and without this embedded donations go unmeasured.
 * `analytics_storage` only, as our banner grants: registering an advertising service means revisiting this
 * and `loadGtag`.
 */
export const grantEmbeddedConsent = (): void => {
	gtag('consent', 'update', { analytics_storage: 'granted' });
};
